import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { faFileInvoice, faFileZip, faFileExcel } from '@fortawesome/free-solid-svg-icons'
library.add(faFileInvoice)
library.add(faFileExcel)
import { library } from '@fortawesome/fontawesome-svg-core'
import TabLista from '../AnexosComponent/ToolBarComponent/TabLista';
import TabContext from '@mui/lab/TabContext';
import TabPaneles from '../AnexosComponent/ToolBarComponent/TabPaneles';
import DatosGeneralesComponent from '../AnexosComponent/DatosGeneralesComponent';
import InstalacionesComponent from '../AnexosComponent/InstalacionesComponent';
import TabsMarcasComponent from '../AnexosComponent/MarcasComponent/TabsMarcasComponent';
import DocumentacionGeneralComponent from '../AnexosComponent/DocumentacionComponent/DocumentacionGeneralComponent';


function InformacionClienteComponent(props) {

    const informacionCliente = useSelector(store => store.SolicitudesFC01_OC.informacionCliente)
    const dataUser = useSelector(store => store.Usuario.user)

    const [value, setValue] = React.useState('datosGenerales');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Fragment>
            {dataUser[0]?.tipousuario?.idtipousuario == 11 &&
                <h3 className='text-center pt-3' style={{ fontWeight: 'bolder', fontFamily: 'Montserrat' }}>SOLICITUD EN REVISIÓN OC <br /></h3>
            }
            <div className='container mt-5 pt-2'>
                <TabContext value={value} >
                    <TabLista value={value} handleChange={handleChange} data={informacionCliente} />

                    <TabPaneles value="datosGenerales">
                        <DatosGeneralesComponent data={informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]} />
                    </TabPaneles>

                    <TabPaneles value="Instalaciones">
                        <div className='row mt-5'>
                            {informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.anexocliente?.map((anexo, index) =>
                                <div key={index} className='col-12 col-md-12 mt-5'>
                                    <InstalacionesComponent data={anexo} />
                                </div>
                            )}
                        </div>
                    </TabPaneles>

                    <TabPaneles value="marcas">
                        <TabsMarcasComponent detalle={informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]} />
                    </TabPaneles>

                    <TabPaneles value="documentacion">
                        <DocumentacionGeneralComponent detalle={informacionCliente?.fc_01_solicitudderegistro} />

                    </TabPaneles>

                </TabContext>
               
            </div>

        </Fragment>
    )
}

export default withRouter(InformacionClienteComponent)